'use strict';

var App = require('app');
var AppState = require('app_state');
var i18n = require('utils/i18n');

var ProfileMFADialog = Marionette.ItemView.extend({
    template: require('components/profile/templates/profile_mfa_dialog'),

    ui: {
        codeInput: 'input#js-code',
    },

    events: {
        'click #js-save': 'save',
        'click #js-cancel': 'cancel',
        'click #js-delete': 'delete',
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.code = this.code;
        data.error = this.error;

        data.mfa_active = AppState.user ? AppState.user.get('mfa_active') : false;
        data.mfa_activation = this.options.mfaActivation;

        return data;
    },

    handleErrorResponse: function (error) {
        if (error) {
            this.error = i18n.TR(error);
            this.render();
            return;
        }

        if (this.options.onSuccess) {
            this.options.onSuccess();
        }
    },

    save: function (e) {
        var code = this.ui.codeInput.val().trim();
        this.code = code;

        // basic validation: number with 6 digits expected
        if (code.length != 6 || parseInt(code) + '' != code) {
            this.error = i18n.TR('6 stelliger Zahlencode');
            this.render();
            return;
        }

        // save
        var self = this;
        var req = App.request('user:mfa:activate', code);

        $.when(req).done(function (error) {
            self.handleErrorResponse(error);
        });
    },

    cancel: function (e) {
        if (this.options.mfaActivation) {
            App.hideModal();
            Backbone.history.loadUrl(Backbone.history.fragment);
        }
    },

    delete: function (e) {
        var self = this;
        var req = App.request('user:mfa:deactivate');

        $.when(req).done(function (error) {
            self.handleErrorResponse(error);
        });
    },
});

module.exports = ProfileMFADialog;
